// Single source of truth for INTERNAL Quote Cost Intelligence configuration.
// Advisory only — never rejects a quote, never changes customer price, never overrides
// governed BLA-STD-007 pricing. Thresholds are INITIAL OPERATING values, Founder-configurable.

// Initial operating margin-health thresholds (gross margin %). Founder-gated to change.
export const MARGIN_THRESHOLDS = {
  healthy: 25,       // >= 25%
  low: 10,           // >= 10% and < 25%
  nearBreakEven: 0,  // >= 0% and < 10%
  // < 0% => below estimated BlueLock cost
};

export const classifyMarginHealth = (marginPct, belowCost) => {
  // NOTE: these classifications are PROPOSED / FOUNDER-APPROVAL PENDING — not BlueLock policy,
  // not BLA-STD-007, not a governed minimum. Only the objective below-cost state is authoritative.
  if (belowCost || (marginPct != null && marginPct < MARGIN_THRESHOLDS.nearBreakEven)) {
    return { key: 'below_cost', label: 'Below estimated BlueLock cost', tone: 'rose', proposed: false };
  }
  if (marginPct == null) return { key: 'unknown', label: 'Margin unavailable', tone: 'slate', proposed: false };
  if (marginPct >= MARGIN_THRESHOLDS.healthy) return { key: 'healthy', label: 'Healthy margin', tone: 'green', proposed: true };
  if (marginPct >= MARGIN_THRESHOLDS.low) return { key: 'low', label: 'Low margin', tone: 'amber', proposed: true };
  return { key: 'near_break_even', label: 'Near break-even', tone: 'amber', proposed: true };
};

// Threshold governance status — surfaced in the UI so nobody mistakes these for approved policy.
export const THRESHOLD_STATUS = 'PROPOSED — Founder approval pending (not BlueLock policy / not BLA-STD-007)';

// Cost-source classification — never silently present ESTIMATE as CONFIRMED or ACTUAL.
export const COST_SOURCE = {
  CONFIRMED: { key: 'confirmed', label: 'Confirmed', desc: 'From an authoritative source (entered/verified value, vendor quote, reservation).' },
  MARKET: { key: 'market', label: 'Market estimate', desc: 'Derived from current/recent external market information.' },
  SYSTEM: { key: 'system', label: 'System estimate', desc: 'Calculated from confirmed + disclosed assumptions.' },
  ACTUAL: { key: 'actual', label: 'Actual', desc: 'Recorded from authoritative information after the job.' },
};

// Deterministic confidence from completeness + manual-assumption density (no fake % precision).
export const estimateConfidence = ({ completeness, missingCount = 0, manualCount = 0, marketUsed = false }) => {
  if (completeness === 'missing') return { key: 'low', label: 'Low confidence' };
  if (completeness === 'partial' || missingCount > 0) return { key: 'moderate', label: 'Moderate confidence' };
  if (marketUsed) return { key: 'moderate', label: 'Moderate confidence' };
  return { key: 'high', label: 'High confidence' };
};

export const HEALTH_TONES = {
  green: 'bg-green-100 text-green-700 border-green-200',
  amber: 'bg-amber-100 text-amber-700 border-amber-200',
  rose: 'bg-rose-100 text-rose-700 border-rose-200',
  slate: 'bg-gray-100 text-gray-600 border-gray-200',
};
